import { useSliderLayout } from '../hooks/useSliderLayout';

type PaginationDotsContainerProps = { children: React.ReactNode };

const PaginationDotsContainer = ({ children }: PaginationDotsContainerProps) => {
	const { blockClass } = useSliderLayout();

	return (
		<div
			className={`paginationDotsContainer paginationDotsContainer--${blockClass} vtex-slider-layout-0-x-paginationDotsContainer vtex-slider-layout-0-x-paginationDotsContainer--${blockClass} flex absolute justify-center pa0 ma0 bottom-0 left-0 right-0`}
		>
			{children}
		</div>
	);
};

export default PaginationDotsContainer;
